import { render, staticRenderFns } from "./LogoDefault.vue?vue&type=template&id=12d96246&"
import script from "./LogoDefault.vue?vue&type=script&lang=js&"
export * from "./LogoDefault.vue?vue&type=script&lang=js&"
import style0 from "./LogoDefault.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports